import { InputField } from '@atoms/input';
import { SwitchField } from '@atoms/switch';
import BlockBase from '@components/dnd/base/blockBase';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { useAtom } from '@hooks/useAtom';
import EndControlsFB, {
  type SettingsConfig
} from '@library/formBuilder/endControls';
import { type DNDBlock, ResolvedVariableType } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';
import type { ChangeEvent } from 'react';
import { useParams } from 'react-router-dom';
import { ParamsList } from '@/routes/routes.types';

import { initialNumberData } from './number.data';
import { NumberIcon } from './number.utils';
import { NumberFieldModal } from './numberField.modal';

const NumberField = (block: DNDBlock) => {
  const actionId = useParams()[ParamsList.ActionId] as string;

  const atom = useAtom({
    type: 'Number',
    parentId: actionId,
    sourceId: block.id,
    parentKind: 'form_action',
    initialData: initialNumberData,
    variableInfo: {
      resolvedType: ResolvedVariableType.Number
    }
  });

  if (!atom) {
    return null;
  }

  const getSettingsModal = (): SettingsConfig => ({
    title: atom.data.title || 'Number title',
    content: <NumberFieldModal atom={atom} />
  });

  const getEndControls = () => (
    <EndControlsFB
      dataItem={atom}
      dndBlock={block}
      hasRequired
      settings={getSettingsModal()}
    />
  );

  const onIntegerChange = (e: ChangeEvent<HTMLInputElement>): void => {
    atom.data.type = e.target.checked ? 'integer' : 'number';
  };

  return (
    <BlockBase
      dataItem={atom}
      dndBlock={block}
      endControls={getEndControls()}
      icon={NumberIcon}
      title={atom.data.title}
    >
      <Column>
        <InputField
          label="Field title"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            atom.data.title = e.target.value;
          }}
          placeholder="Aa"
          required
          value={atom.data.title}
        />
      </Column>

      <Column>
        <InputField
          label="Placeholder"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            atom.data.placeholder = e.target.value;
          }}
          placeholder="Aa"
          value={atom.data.placeholder}
        />
      </Column>
      <Column $gap="0">
        <SwitchField
          checked={atom.data.type === 'integer'}
          label="Integer"
          onChange={e => onIntegerChange(e)}
          title="Additional features"
        />
      </Column>
    </BlockBase>
  );
};

export default observer(NumberField);
